import { getInitials } from '../../utils/data/get-initials';
import type { Agent as AgentModel } from './agent.type';
import type { Agent } from './agent.type.ts';
export interface AgentExtension extends Agent {}
export class AgentExtension {
  // ── Computed Properties ──
  get fullName() {
    return [this.firstName, this.lastName].join(' ');
  }

  get initials(): string {
    return getInitials(this as unknown as AgentModel);
  }
}

const Registration = {
  kind: 'object',
  name: 'agent',
  features: AgentExtension,
};
export default Registration;
